module.exports = __webpack_public_path__ + "img/ProfileIcon.bcf60d4c.svg";